import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link, withRouter} from 'react-router-dom';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuActive: ''
        }
    }

    componentDidMount() {
        let {location} = this.props;
        let {pathname} = location;
        this.setState({
            menuActive: pathname
        });
    }

    onClickMenu(menu) {
        this.setState({
            menuActive: menu
        });
    }

    render() {
        let {menuActive} = this.state;
        let {vendor} = this.props;
        if (!vendor) return '';
        return (
            <div className="col-sm-3 col-md-2 sidebardb">
                <ul className="nav nav-sidebar">
                    {/* <li className={menuActive == '/' ? 's1 active' : 's1'}>
                        <Link to="/" onClick={this.onClickMenu.bind(this, '/')}>
                            Dashboard
                        </Link>
                    </li> */}
                    <li className={menuActive == '/profile' ? 'active' : ''}>
                        <Link to="/profile" onClick={this.onClickMenu.bind(this, '/profile')}>
                            My Profile
                        </Link>
                    </li>
                    <li className={menuActive == '/quotes' ? 'active' : ''}>
                        <Link to="/quotes" onClick={this.onClickMenu.bind(this, '/quotes')}>
                            Live Bids
                        </Link>
                    </li>
                    <li className={menuActive === '/projects' ? 'active' : ''}>
                        <Link to="/projects" onClick={this.onClickMenu.bind(this, '/projects')}>
                            Live Projects
                        </Link>
                    </li>
                    {vendor.type !== 'pm' && (
                        <li className={menuActive == '/items' ? 'active' : ''}>
                            <Link to="/items" onClick={this.onClickMenu.bind(this, '/items')}>
                                Items
                            </Link>
                        </li>
                    )}
                    {/* <li className={menuActive == '/psr' ? 'active' : ''}>
                        <a href="#" onClick={this.onClickMenu.bind(this, '/psr')}>
                            PRS
                        </a>
                    </li> */}
                </ul>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {vendor} = state;
    return { 
        vendor
    }
}

export default connect(mapStateToProps)(withRouter(Sidebar));